import {connect} from 'react-redux'
import {selectBranch} from '../../services/actions/action'
import HomeCalling from '../../components/HomeCalling'

const mapStateToProps = state => ({
    data:state.userItems
})

const mapDispatchToProps = dispatch => ({
    selectBranchHandler:data=>dispatch(selectBranch(data))
})

export default connect(mapStateToProps,mapDispatchToProps)(HomeCalling)